var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:safety-certificate-fill",
    clipPath: "url(#clip0_2430_20693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8651 2.90155C15.3838 2.70749 15.9506 2.68219 16.4845 2.82926L16.7105 2.90155L25.9112 6.35181C26.3777 6.52675 26.7849 6.83065 27.0854 7.22812C27.3858 7.62558 27.5671 8.10024 27.6081 8.59678L27.6173 8.81366V15.8627C27.6173 17.9926 27.0422 20.0829 25.9528 21.9131C24.8634 23.7432 23.3001 25.2453 21.4279 26.2608L21.0782 26.4435L16.6698 28.6477C16.4271 28.7689 16.1619 28.8387 15.891 28.8527C15.62 28.8668 15.3491 28.8247 15.0952 28.7292L14.9059 28.6477L10.4974 26.4435C8.59238 25.491 6.97985 24.0417 5.83006 22.2488C4.68028 20.4559 4.0359 18.3858 3.96495 16.257L3.95837 15.8627V8.81366C3.95838 8.31568 4.09984 7.82794 4.36627 7.40723C4.63271 6.98652 5.01316 6.65014 5.46335 6.43725L5.66445 6.35181L14.8651 2.90155V2.90155ZM20.3001 11.3583L14.2566 17.4018L11.9327 15.078C11.6861 14.8316 11.3517 14.6932 11.003 14.6933C10.6543 14.6934 10.32 14.832 10.0736 15.0787C9.82709 15.3253 9.6887 15.6597 9.68883 16.0084C9.68895 16.3571 9.82758 16.6914 10.0742 16.9379L13.234 20.0977C13.3683 20.232 13.5277 20.3385 13.7031 20.4112C13.8786 20.4839 14.0667 20.5214 14.2566 20.5214C14.4465 20.5214 14.6346 20.4839 14.81 20.4112C14.9855 20.3385 15.1449 20.232 15.2792 20.0977L22.1587 13.2168C22.2842 13.0956 22.3843 12.9506 22.4532 12.7902C22.5221 12.6298 22.5584 12.4574 22.5599 12.2828C22.5614 12.1083 22.5281 11.9352 22.4621 11.7737C22.396 11.6122 22.2984 11.4654 22.175 11.342C22.0515 11.2186 21.9048 11.121 21.7433 11.0549C21.5817 10.9888 21.4086 10.9556 21.2341 10.9571C21.0596 10.9586 20.8871 10.9949 20.7268 11.0638C20.5664 11.1326 20.4214 11.2328 20.3001 11.3583V11.3583Z",
    fill: "#0062FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2430_20693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.5452,
    height: 31.5452,
    fill: "white",
    transform: "translate(0.0159912 0.0161133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.92e526d10d5dc787180c44b32bef3e7e.svg";
export { ForwardRef as ReactComponent };